import { ELoanStatuses, IFormattedLoan } from 'store/fetchers/loans/enum'
import BigNumber from 'bignumber.js'

interface FilterItem {
  id: string
  title: string
  statuses?: ELoanStatuses[]
}

export enum LoanStatus {
  AllLoans = 'allLoans',
  Active = 'active',
  Closed = 'closed',
  Liquidated = 'Liquidated',
}

export const filterItems: Record<LoanStatus, FilterItem> = {
  [LoanStatus.AllLoans]: { id: LoanStatus.AllLoans, title: 'All loans', statuses: [] },
  [LoanStatus.Active]: {
    id: LoanStatus.Active,
    title: 'Active',
    statuses: [ELoanStatuses.ORDER_CREATED],
  },
  [LoanStatus.Closed]: {
    id: LoanStatus.Closed,
    title: 'Closed',
    statuses: [ELoanStatuses.CLOSED],
  },
  [LoanStatus.Liquidated]: {
    id: LoanStatus.Liquidated,
    title: 'Liquidated',
    statuses: [ELoanStatuses.LIQUIDATED],
  },
}

export const sortByAssetName = (list: IFormattedLoan[], sorting: number): IFormattedLoan[] => {
  const sortedList = [...list]

  if (sorting === 1) {
    sortedList.sort((loan1, loan2) => {
      const assetName1 = loan1.deposit.currency_code.toLowerCase()
      const assetName2 = loan2.deposit.currency_code.toLowerCase()
      if (assetName1 > assetName2) return 1
      if (assetName1 < assetName2) return -1
      return 0
    })

    return sortedList
  }

  if (sorting === 2) {
    sortedList.sort((loan1, loan2) => {
      const assetName1 = loan1.deposit.currency_code.toLowerCase()
      const assetName2 = loan2.deposit.currency_code.toLowerCase()
      if (assetName1 < assetName2) return 1
      if (assetName1 > assetName2) return -1
      return 0
    })

    return sortedList
  }

  return list
}

export const sortByDate = (list: IFormattedLoan[], sorting: number): IFormattedLoan[] => {
  const sortedList = [...list]

  if (sorting === 1) {
    sortedList.sort((loan1, loan2) =>
      new BigNumber(new Date(loan1.created_at).getTime()).minus(new Date(loan2.created_at).getTime()).toNumber(),
    )

    return sortedList
  }

  if (sorting === 2) {
    sortedList.sort((loan1, loan2) =>
      new BigNumber(new Date(loan2.created_at).getTime()).minus(new Date(loan1.created_at).getTime()).toNumber(),
    )

    return sortedList
  }

  return list
}

export const sortByMarginCall = (list: IFormattedLoan[], sorting: number): IFormattedLoan[] => {
  const sortedList = [...list]

  if (sorting === 1) {
    sortedList.sort((loan1, loan2) => new BigNumber(loan1.liquidation_price).minus(loan2.liquidation_price).toNumber())

    return sortedList
  }

  if (sorting === 2) {
    sortedList.sort((loan1, loan2) => new BigNumber(loan2.liquidation_price).minus(loan1.liquidation_price).toNumber())

    return sortedList
  }

  return list
}

const ONE_DAY_MS = 86400000

export const hasDayPassed = (givenDateString: string) => {
  const givenDate = new Date(givenDateString).getTime()
  const currentDate = new Date().getTime()
  const difference = currentDate - givenDate
  return difference >= ONE_DAY_MS
}
